import { render, staticRenderFns } from "./BrowseCategories.vue?vue&type=template&id=7fc6cb21&scoped=true&"
import script from "./BrowseCategories.ts?vue&type=script&lang=ts&"
export * from "./BrowseCategories.ts?vue&type=script&lang=ts&"
import style0 from "./BrowseCategories.vue?vue&type=style&index=0&id=7fc6cb21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6cb21",
  null
  
)

export default component.exports